var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('flickity',{ref:"flickity",attrs:{"options":_vm.options}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }